// The wall clock, with the civil date taken in Europe/Paris. Browser-safe: it
// names no infrastructure, so the browser services and the server-only
// booking engine share it.

import type { Clock, Instant, IsoDate } from '@lemontaigu/pms-core';

export const systemClock: Clock = {
  now: () => new Date().toISOString() as Instant,
  todayParis: () =>
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' }).format(new Date()) as IsoDate,
};
